import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-details-snackbar',
  templateUrl: './details-snackbar.component.html',
  styleUrls: ['./details-snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DetailsSnackbar implements OnInit {
  showDiv: string;
  message: string;
  extraMessage: string;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}

  ngOnInit() {
    // data from parent component
    console.log('data in details snackbar');
    console.log(`${JSON.stringify(this.data)}`);
    if (this.data.location === 'checkout BX') {
      this.message = this.data.message;
      this.extraMessage = this.data.extraMessage;
      this.showDiv = this.data.location;
    }
  }
}
